import {Spin} from "antd";
import React from "react";

export const Loader = () => {
    return (
        <div style={{textAlign: 'center', padding: '50px'}}>
            <Spin size="large"/>
            <div style={{marginTop: 16}}>Загрузка данных...</div>
        </div>
    );
}